import React, { useEffect } from 'react';
import { css } from '@emotion/react';
import { Spinner } from '~/components/atomic';
import { MessageResponse } from '~/types';
import { useCommonChatStore } from '~/store';
import ChatBox from './ChatBox';
import * as S from './ChatContent.styled';

interface ChatContentProps {
  type: 'group' | 'single';
  messages: MessageResponse[];
  isLoading: boolean;
  waitingChat: boolean;
  infoMessageRef: any;
  isPaginationPending: boolean;
  chatSectionRef: React.RefObject<HTMLDivElement>;
  prevHeight: number | null;
}

export default function ChatContent({
  type,
  messages,
  isLoading,
  waitingChat,
  infoMessageRef,
  isPaginationPending,
  chatSectionRef,
  prevHeight,
}: ChatContentProps) {
  const isTextFocus = useCommonChatStore((state) => state.isTextFocus);

  useEffect(() => {
    if (!chatSectionRef.current) return;
    if (!prevHeight) return;
    if (!isPaginationPending) {
      chatSectionRef.current.scrollTop = prevHeight;
    }
  }, [isPaginationPending, prevHeight]);

  useEffect(() => {
    if (!chatSectionRef.current) return;

    if (chatSectionRef.current.scrollTop > -200)
      chatSectionRef.current.scrollTop = 0;
  }, [messages.length, waitingChat]);

  const displayedMessages = isTextFocus
    ? [{ ...messages[messages.length - 1] }]
    : [...messages];
  const isInfoMessageOn = !isTextFocus && messages.length > 0;

  return (
    <S.ChatContainer>
      <S.ChatSection ref={chatSectionRef}>
        {!isLoading && (
          <ChatBox
            type={type}
            waitingChat={waitingChat}
            messages={displayedMessages}
            isInfoMessageOn={isInfoMessageOn}
            infoMessageRef={infoMessageRef}
            isPaginationPending={isPaginationPending}
          />
        )}
      </S.ChatSection>
    </S.ChatContainer>
  );
}
